// extracted by mini-css-extract-plugin
export default {"description":"AvatarDescription_description__FKuET","name":"AvatarDescription_name__GK8TP","rol":"AvatarDescription_rol__a6BBo"};